import { combineReducers } from 'redux';
import Auth from './auth/reducers';
import secretariaReducer from './secretaria/reducers';
import defautReducer from './default/reducers';

export default combineReducers({
    Auth,
    secretariaReducer,
    defautReducer
});